import {Route, Routes} from "react-router-dom";
import AuthorGallery from "./gallery";
import AuthorDetails from "./detailled";
import CreateAuthor from "./create";
import UpdateAuthor from "./update";

import VerticalMenu from '../../components/VerticalMenu'
import { Col, Row} from "react-bootstrap";
import { useAppStore } from '../../context/state'
/**
 * 
 * @param {{menu, letters, gallery, lang: json}} props 
 * @returns 
 */

export default function Authors(props) {
    const { commonmenu } = useAppStore.getState().settings

    return (
        <Row>
            <Col xs={{ span: 12, order: 2 }} sm={{ span: 12, order: 2 }} md={{ span: 3, order: 1 }} xl={2} style={{ /*minHeight:'100vh' */ }}>
                <VerticalMenu url="/editorial/authors" menu={commonmenu} />
            </Col>
            <Col xs={{ span: 12, order: 1 }} sm={{ span: 12, order: 1 }} md={{ span: 9, order: 2 }} xl={10}>
            <Routes>
                <Route path="/" exact element={<AuthorGallery {...props}/>}></Route>
                <Route path="/:letter/search" exact element={<AuthorGallery {...props}/>}></Route>
                <Route path="/:id" exact element={<AuthorGallery {...props}/>}></Route>
                {/* <Route path="/:id" exact element={<AuthorDetails {...props}/>}></Route> */}

                {/* TODO: Remover puertas traseras */}
                <Route path="/create" exact element={<CreateAuthor {...props}/>}></Route>
                <Route path="/:id/update" exact element={<UpdateAuthor {...props}/>}></Route>

                <Route path="*" exact element={<></>} /> {/* aqui debería ir Page Not Found */}
            </Routes>
            </Col>
        </Row>
    )
}
